import { TSiteTemplate } from '../../types';
import { templateMutationSchema } from './templateMutationSchema';

export const templateCollectionMutationSchema = (
  collection: Record<string, TSiteTemplate>
): Record<string, TSiteTemplate> => {
  const newCollection: Record<string, TSiteTemplate> = {};

  for (const [key, template] of Object.entries(collection)) {
    const newTemplate = templateMutationSchema(template);
    newCollection[key] = newTemplate;
  }

  return newCollection;
};
